import type React from "react";

import { CheckboxIcon } from "@similarweb/ui-components";

import type { TabbedDropdownItemType } from "app/pages/sales-intelligence/types/types";

import { StyledItemContainer, StyledItemCheckbox, StyledPlainTooltip } from "./styles";

export type DropdownWithTabsItemProps = {
    item: TabbedDropdownItemType;
    itemHeight?: number;
    onClick(): void;
    renderText(item: TabbedDropdownItemType): React.ReactNode;
    isSingleSelect?: boolean;
    tooltipForDisabledItem?: string;
};

const DropdownWithTabsItem = (props: DropdownWithTabsItemProps) => {
    const { item, itemHeight, onClick, renderText, isSingleSelect, tooltipForDisabledItem } = props;

    const ddContent = (
        <>
            {renderText(item)}
            <StyledItemCheckbox>
                {isSingleSelect ? null : (
                    <CheckboxIcon
                        selected={item.isSelected}
                        disabled={item.isDisabled}
                    />
                )}
            </StyledItemCheckbox>
        </>
    );
    if (item.isDisabled) {
        const disabledContainer = (
            <StyledItemContainer
                isDisabled={item.isDisabled}
                itemHeight={itemHeight}
                data-automation="dd-item"
            >
                {ddContent}
            </StyledItemContainer>
        );

        if (tooltipForDisabledItem) {
            return (
                <StyledPlainTooltip
                    tooltipContent={tooltipForDisabledItem}
                    enabled={true}
                    cssClass="plainTooltip-element technologies-dd-tooltip"
                >
                    <div>{disabledContainer}</div>
                </StyledPlainTooltip>
            );
        }

        return disabledContainer;
    }

    return (
        <StyledItemContainer
            onClick={onClick}
            itemHeight={itemHeight}
            data-automation="dd-item"
        >
            {ddContent}
        </StyledItemContainer>
    );
};

export default DropdownWithTabsItem;
